export default __webpack_public_path__ + "static/media/1533.1e14c983.png";